"use client"

import { ReactNode, useEffect, useState } from "react"
import { useUbStorefrontState } from "@/store/ubStorefrontState"

interface StorefrontContextResponse {
  isB2B: boolean
}

export default function UbBenefitBannerClient(props: {
  leftB2B: ReactNode
  leftB2C: ReactNode
  centerB2B: ReactNode
  centerB2C: ReactNode
  rightB2B: ReactNode
  rightB2C: ReactNode
  sbLocale?: string
}) {
  const { isB2BCustomer, setIsB2BCustomer } = useUbStorefrontState()
  const [effectiveIsB2B, setEffectiveIsB2B] = useState(isB2BCustomer)

  useEffect(() => {
    let cancelled = false
    const contextUrl = props.sbLocale
      ? `/api/storefront/context?sbLocale=${encodeURIComponent(props.sbLocale)}`
      : "/api/storefront/context"

    fetch(contextUrl, {
      cache: "no-store",
    })
      .then((response) => (response.ok ? response.json() : undefined))
      .then((context: StorefrontContextResponse | undefined) => {
        if (!cancelled && context) {
          setEffectiveIsB2B(context.isB2B)
          setIsB2BCustomer(context.isB2B)
        }
      })
      .catch(() => undefined)

    return () => {
      cancelled = true
    }
  }, [props.sbLocale, setIsB2BCustomer])

  const isB2C = !effectiveIsB2B

  return (
    <>
      <div className={"border-b-2 border-white pb-8 pl-10 lg:flex-1 lg:border-r-2 lg:border-b-0 lg:pr-8 lg:pb-0"}>
        {isB2C ? props.leftB2C : props.leftB2B}
      </div>
      <div
        className={"border-b-2 border-white py-8 pl-10 lg:flex-1 lg:border-r-2 lg:border-b-0 lg:py-0 lg:pr-8 lg:pl-16"}
      >
        {isB2C ? props.centerB2C : props.centerB2B}
      </div>
      <div className={"pt-8 pl-10 lg:flex-1 lg:pt-0 lg:pl-16"}>{isB2C ? props.rightB2C : props.rightB2B}</div>
    </>
  )
}
